export default __webpack_public_path__ + "static/media/path-cut-shadow.a3ca5d6c.png";